import Axios from "axios";
import config from "../../config/local-config";
import apiConfig from "../../config/api-config";
import { urlEncode } from "@usap/core";

const getCategoryParts = async (url) => {
    
    const version = "v1";
    const serviceName = "pages";
    const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}?&uri=/${urlEncode(url)}`;
    
    let body = {
        domain: config.hydra.site
    };

    return Axios.get(apiUrl, {
        params: body,
        headers: { apikey: apiConfig.apiKey }
    });
};

export default getCategoryParts;

